// "Wat past bij ons gezin" (0023; docs/DESIGN.md §8.P): typen en calls voor /v1/app/profile*.
// Zelfde vorm als packages/domain schemas/profile.ts (de API is leidend); handgeschreven zoals de
// rest van deze client en kiosk-veilig (alleen types). Alleen de ouderapp gebruikt dit; de kiosk
// krijgt nooit het profiel. Nooit profielcodes in een URL: alles gaat in de body.
export function createProfileApi({ request, id }) {
    return {
        get: () => request('GET', '/v1/app/profile'),
        /** Alleen de eigen afwijking (kind van 16+ met eigen login); can_set false voor de rest. */
        self: () => request('GET', '/v1/app/profile/self'),
        save: (input) => request('PUT', '/v1/app/profile', input),
        saveMember: (memberId, input) => request('PUT', `/v1/app/profile/members/${id(memberId)}`, input),
        withdraw: () => request('DELETE', '/v1/app/profile/consent', { confirm: true }),
        withdrawSelf: () => request('DELETE', '/v1/app/profile/consent/self', {
            confirm: true,
        }),
        invite: (action) => request('POST', '/v1/app/profile/invite', { action }),
        /** Gegevensexport (JSON; step-up): alles (owner) of één lid (owner, of een ouder voor zichzelf). */
        exportAll: () => request('GET', '/v1/app/export'),
        exportMember: (memberId) => request('GET', `/v1/app/export/members/${id(memberId)}`),
    };
}
//# sourceMappingURL=profile.js.map